import { useState, useEffect } from 'react';
import useInterval from '../useInterval';
import styles from './css/main.module.css'
import Header from './header.js'
import Contents from './contents.js'
import '@aws-amplify/ui-react/styles.css'
import { Authenticator } from "@aws-amplify/ui-react";
import { Auth } from 'aws-amplify';
import Sidebar from "./sidebar.js"
import Site from "./site.js"
import Dashboard from "./dashboard.js"
import Support from "./support.js"
import Guide from "./guide.js"
import Edit from "./edit.js"
import invoke from "../calllambda.js"
import sensorstatus from "./sensorstatus.js"
import Realtimemonitor from "./realtimemonitor.js"
import stylessite from './css/site.module.css' 

function AuthHeader() {
  return <div style={{ paddingLeft: "0.5em", backgroundColor: "gray", color: "white", textAlign: "left", fontWeight: "bold", fontSize: "xx-large" }}>ログイン</div>
}

function NewPasswordHeader() {
  return (
    <div>
      <h2>パスワードを変更してください</h2>
      <ul style={{ fontSize: '0.9rem', color: '#666' }}>
        <li>8文字以上</li>
        <li>大文字と小文字を含む</li>
        <li>数字を含む</li>
        <li>記号を含む（{"^$*.[]{}()?-\"!@#%&/\\,><':;|_~`+="}）</li>
      </ul>
    </div>
  )
}

function Main(props) {
  return (
    <Authenticator hideSignUp components={{ SignIn: { Header: AuthHeader }, ForceNewPassword: { Header: NewPasswordHeader } }}>
      {({ signOut, user }) => (
        <MainContent signOut={signOut} site={props.site}/>
      )}
    </Authenticator>
  )
}

function MainContent(props) {
  const [menu, setMenu] = useState(props.site ? "" : "map");
  const [sites, setSites] = useState([]);
  const [admin, setAdmin] = useState(0);
  const [points, setPoints] = useState([]);
  const [point, setPoint] = useState({});

  async function recoverToLogin() {
    await Auth.signOut();
  }

  function usrinfoupdate() {
    invoke("arn:aws:lambda:ap-northeast-1:068557983663:function:userinformation").then(function (value) {
      if (!value || typeof value !== "object" || !Array.isArray(value.sites) || value.admin === undefined) {
        recoverToLogin();
        return;
      }
      setAdmin(value.admin);
      setSites(value.sites);
      sensorstatusupdate(value.sites)
    }).catch(function () {
      recoverToLogin();
    });
  }

  function sensorstatusupdate(asites, isRefresh = false) {
    if (asites.length > 0 && (!isRefresh || (isRefresh && (menu !== "edit")))) {
      sensorstatus(asites).then(function (value) {
        setPoints(value);
        if (point?.name) {
          updatepoint(point?.name, value);
        }
      });
    }
  }

  useInterval(() => {
    (async () => {
      try {
        await Auth.currentSession();
        sensorstatusupdate(sites, true);
      } catch (error) {
        await Auth.signOut();
      }
    })();
  }, 1000 * 60);

  useEffect(() => {
    usrinfoupdate();
  }, []);

  useEffect(() => {
    if (props.site && points.length > 0) {
      changemenu({ menu: "sinage", site: props.site });
    }
  }, [points,props.site]);



  function changemenu(value) {
    setMenu(value.menu);
    updatepoint(value.site, points);
  }

  function updatepoint(name, apoints) {
    const res = apoints.find((p) => p.name === name)
    if (res) setPoint(res)
  }

  return (
    menu == "" ? <></> :
    menu == "sinage" ? <>
    <Header/>
      <div className={stylessite.modal_header}>
        <div className={stylessite.title}>{point.name}</div>
        <div className={stylessite.discription}>風速:過去1分間の平均・雨量:過去1時間の合計・震度:過去24時間の最大の震度</div>
      </div>
      <Realtimemonitor point={{...point,sensors:{...point.sensors, camera:[]}}}/>
    </>
     :
    <div>
      <div className={styles.header}><Header signout={props.signOut} /></div>
      <div className={styles.sidebar1}><Sidebar sites={sites} menuselect={changemenu} admin={admin} /></div>
      <div className={styles.sidebar2}><Sidebar sites={sites} menuselect={changemenu} admin={admin} small /></div>
      <div className={styles.content} id="print">
        {menu === "map" && <Contents points={points} setsite={changemenu} />}
        {menu === "dashboard" && <Dashboard points={points} setsite={changemenu} />}
        {menu === "site" && <Site point={point} admin={admin} />}
        {menu === "guide" && <Guide />}
        {menu === "support" && <Support />}
        {menu === "edit" && <Edit point={point} update={usrinfoupdate} admin={admin} />}
      </div>
    </div>
  )
}

export default Main;
